import Head from 'next/head'
import Header from '../../components/Header'
import Page from '../../components/Page'
import Footer from '../../components/Footer'
import CommonHeadTags from '../../components/CommonHeadTags'
import {
  GoogleAnalyticsHead,
  GoogleAnalyticsBody,
} from '../../components/GoogleAnalytics'
import useTranslation from '../../translations/useTranslation'
import {
  nonEnglishLocales,
  locales,
  defaultLocale,
  isLocale,
  localeHreflangs,
} from '../../translations/config'
import { LocaleProvider } from '../../translations/context'

const Home = ({ locale }) => {
  const { t } = useTranslation(locale)
  const canonicalUrl = locale === 'en'
    ? 'https://guitar-tuner.org'
    : `https://guitar-tuner.org/${locale}`
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Guitar-Tuner.org',
    url: canonicalUrl,
    description: t('description'),
    inLanguage: localeHreflangs[locale],
    publisher: {
      '@type': 'Organization',
      name: 'ChordChord OÜ',
      url: 'https://guitar-tuner.org/about',
    },
  }

  return (
    <>
      <Head>
        <title>{t('title')}</title>
        <meta name='description' content={t('description')} />
        <meta httpEquiv='content-language' content={localeHreflangs[locale]} />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
        />
        {locale === 'en' ? (
          <link rel='canonical' href='https://guitar-tuner.org' />
        ) : (
          <link rel='canonical' href={`https://guitar-tuner.org/${locale}`} />
        )}
        <link
          rel='alternate'
          hrefLang='x-default'
          href='https://guitar-tuner.org'
        />
        <link rel='alternate' hrefLang='en' href='https://guitar-tuner.org' />
        {nonEnglishLocales.map((locale) => (
          <link
            key={locale}
            rel='alternate'
            hrefLang={localeHreflangs[locale]}
            href={`https://guitar-tuner.org/${locale}`}
          />
        ))}
        <CommonHeadTags
          title={t('title')}
          description={t('description')}
          url={canonicalUrl}
        />
        <GoogleAnalyticsHead />
      </Head>

      <LocaleProvider lang={locale || defaultLocale}>
        <Header />
        <main>
          <Page pageData='home' />
        </main>
        <Footer />
      </LocaleProvider>
      <GoogleAnalyticsBody />
    </>
  )
}

export async function getStaticProps(ctx) {
  if (typeof ctx.params.lang !== 'string' || !isLocale(ctx.params.lang)) {
    // in case the value of 'lang' is not a valid locale return it as undefined
    return { props: { locale: undefined } }
  }

  // the locale is valid
  return { props: { locale: ctx.params.lang } }
}

export async function getStaticPaths() {
  return {
    paths: locales.map((locale) => {
      return {
        params: { lang: locale },
      }
    }),
    fallback: false,
  }
}

export default Home
